import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    ContentChild, Directive, EventEmitter,
    Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild, ViewContainerRef
} from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { NavigationService } from '../../../services/navigation.service';
import { PermissionDeniedPage } from '../../pages/not-permitted.page';

@Directive({
    selector: '[navigationContent]'
})
export class NavigationContentDirective { }

@Component({
    selector: 'evi-nav',
    templateUrl: './navigation.control.html',
    styleUrls: ['./navigation.control.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavigationControl implements OnInit, OnDestroy {

    Instance: any;
    componentRef: any;
    SelectedNavigation: any;
    Path = [];
    ActiveURL: string;
    BaseURL: string;

    @ContentChild(NavigationContentDirective, { read: TemplateRef }) navigationContentTemplate: any;
    @ViewChild('dynamic', { read: ViewContainerRef }) viewContainerRef: ViewContainerRef;

    //#region NavigationItems
    NavigationItemsValue = [];

    @Input()
    get NavigationItems() {
        return this.NavigationItemsValue;
    }
    set NavigationItems(val) {
        this.NavigationItemsValue = val;
        this.SearchComponent();
        this.NavigationItemsChange.emit(this.NavigationItemsValue);
        this.cdRef.detectChanges();
    }

    @Output() NavigationItemsChange = new EventEmitter<any>();
    //#endregion

    //#region SelectionHandler
    SelectionHandlerValue: any;

    @Input()
    get SelectionHandler() {
        return this.SelectionHandlerValue;
    }
    set SelectionHandler(val) {
        this.SelectionHandlerValue = val;
        this.SelectionHandlerChange.emit(this.SelectionHandlerValue);
    }

    @Output() SelectionHandlerChange = new EventEmitter<any>();
    //#endregion

    //#region ShowPath
    ShowPathValue = false;

    @Input()
    get ShowPath() {
        return this.ShowPathValue;
    }
    set ShowPath(val) {
        this.ShowPathValue = val;
        this.ShowPathChange.emit(this.ShowPathValue);
    }

    @Output() ShowPathChange = new EventEmitter<any>();
    //#endregion
    //#region DeepLinking
    DeepLinkingValue = true;

    @Input()
    get DeepLinking() {
        return this.DeepLinkingValue;
    }
    set DeepLinking(val) {
        this.DeepLinkingValue = val;
        this.DeepLinkingChange.emit(this.DeepLinkingValue);
    }

    @Output() DeepLinkingChange = new EventEmitter<any>();
    //#endregion
    //#region SelectionHandler
    ContentStyleValue = {};

    @Input()
    get ContentStyle() {
        return this.ContentStyleValue;
    }
    set ContentStyle(val) {
        this.ContentStyleValue = val;
        this.ContentStyleChange.emit(this.ContentStyleValue);
    }

    @Output() ContentStyleChange = new EventEmitter<any>();
    //#endregion
    SelectionSet: Subject<void> = new Subject();

    NavOpen = false;
    Navs = {};
    Subscriptions = [];

    constructor(private router: Router, public cdRef: ChangeDetectorRef) {
        this.Instance = this;
    }

    ngOnInit(): void {
        this.Subscriptions.push(NavigationService.ActiveURL.subscribe((url) => {
            this.ActiveURL = url;
            this.SearchComponent();
        }));
        this.Subscriptions.push(NavigationService.NavOpenChanged.subscribe((value) => {
            if (value.Value == false) {
                delete this.Navs[value.Instance];
            } else {
                this.Navs[value.Instance] = value.Value
            }
            if (Object.keys(this.Navs).length > 0) {
                this.NavOpen = true;
            } else {
                this.NavOpen = false;
            }
            this.cdRef.detectChanges();
        }));
    }

    ngOnDestroy(): void {
        if (this.componentRef) {
            this.componentRef.destroy();
            this.componentRef = null;
        }
        this.Subscriptions.forEach(x => x.unsubscribe());
        this.Subscriptions = [];
    }

    SearchComponent() {
        if (this.DeepLinking && this.ActiveURL && this.NavigationItemsValue && this.NavigationItemsValue.length > 0) {
            this.ResetSelected();

            const settingsIndex = this.ActiveURL.indexOf("settings") + 9;
            let url = this.ActiveURL.substring(settingsIndex);
            const qIndex = url.indexOf('?');
            if (qIndex > -1) {
                url = url.substring(0, qIndex);
            }

            this.BaseURL = this.ActiveURL.substring(0, settingsIndex);
            if (this.BaseURL[this.BaseURL.length - 1] != '/') {
                this.BaseURL += '/';
            }
            let split = url.split('/');
            let toSearch = this.NavigationItemsValue;
            let lastSelected: any;
            if (split && split.length > 0) {
                for (let i = 0; i < split.length; i++) {
                    let path = split[i];
                    let found = null;
                    toSearch.forEach((item) => {
                        item.Selected = false;
                        if (item.ID.toLowerCase() == path.toLowerCase()) {
                            item.Selected = true;
                            lastSelected = item;
                            found = item.Children;
                        }
                    });
                    if (found) {
                        toSearch = found;
                    }
                }
            }
            this.SelectionSet.next();
            if (lastSelected) {
                this.SetComponent(lastSelected);
            }
        }
    }

    ResetSelected(items?: any[]) {
        if (!items) {
            items = this.NavigationItemsValue;
        }
        items.forEach((item: any) => {
            item.Selected = false;
            if (item.Children && item.Children.length > 0) {
                this.ResetSelected(item.Children);
            }
        })
    }


    async CheckComponent() {
        if (this.SelectionHandlerValue && typeof this.SelectionHandlerValue.CheckComponent === 'function') {
            return await this.SelectionHandlerValue.CheckComponent();
        }
        return true;
    }

    SetComponent(nav: any) {
        this.SelectedNavigation = nav;
        const path = [];
        let children = this.NavigationItemsValue;
        while (children) {
            const selected = children.find(x => x.Selected);
            if (selected && selected !== nav) {
                path.push(selected);
                children = selected.Children;
            } else {
                break;
            }
        }
        this.Path = path;
        let component: any;
        if (this.viewContainerRef) {
            this.viewContainerRef.clear();
            if (nav && (nav.Content || nav.EmptyContent)) {

                if (nav.SecurityValue) {
                    this.componentRef = nav.Content ? this.viewContainerRef.createComponent(nav.Content) :
                        this.viewContainerRef.createComponent(nav.EmptyContent);
                    component = this.componentRef.instance;
                    if (nav.InitArgs) {
                        component.InitArgs = nav.InitArgs;
                    }
                } else {
                    this.componentRef = this.viewContainerRef.createComponent(PermissionDeniedPage);
                    component = this.componentRef.instance;
                }
            }
        }
        if (this.SelectionHandlerValue && typeof this.SelectionHandlerValue.SetComponent === 'function') {
            this.SelectionHandlerValue.SetComponent(component);
        }
        this.cdRef.detectChanges();
    }

    OnNavClicked(nav: any) {
        if (this.SelectionHandlerValue && typeof this.SelectionHandlerValue.OnNavClicked === 'function') {
            this.SelectionHandlerValue.OnNavClicked(nav);
        }
    }

    async parentClicked(parent: any) {
        if (this.DeepLinking) {
            if (this.NavigationItems) {
                let path = this.findItem(parent, this.NavigationItems);
                let url = "";
                let count = 0;
                path.forEach((p) => {
                    if (count > 0) {
                        url += "/";
                    }
                    url += p;
                    count += 1;
                });                
                this.router.navigate([this.BaseURL + url]);
                this.SetComponent(parent);
            }
        } else {
            if (parent && parent.NaviTabInstance) {
                await parent.NaviTabInstance.selectItem(null);
            }
        }
    }    

    findItem(nav: any, items: any) {
        let retVal = [];
        if (nav != null && items && items.length > 0) {
            for (let i = 0; i < items.length; i++) {
                let item = items[i];
                if (nav == item) {
                    retVal.push(item.ID);
                }
                if (item.Children && item.Children.length > 0) {
                    let result = this.findItem(nav, item.Children)
                    if (result && result.length > 0) {
                        retVal.push(item.ID);
                        retVal.push(...result);
                    }
                }
            }
        }
        return retVal;
    }
}
